import { makeActions } from '@redux/crudCreator/actions';
import { convertResponseData } from '@redux/crudCreator/dataProvider';
import { apiWrapper } from '@redux/crudCreator/reduxUtils';
import { CreatePayloadType } from '@redux/crudCreator/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { banCustomerApi } from 'api/customers';

export const MODEL_NAME = 'bannedCustomers';
export const bannedCustomersActions = makeActions(
  MODEL_NAME,
  'id',
  'customers',
);

export const getAllBannedCustomers = bannedCustomersActions.getAll;
export const editBannedCustomers = bannedCustomersActions.edit;
export const createBannedCustomers = bannedCustomersActions.create;
export const getByIdBannedCustomers = bannedCustomersActions.getDataById;

export const banCustomer = createAsyncThunk(
  'auth/banCustomer',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(null, banCustomerApi, data);
      const result = convertResponseData('CREATE', response);
      if (result) {
        return { data: result, success: true };
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);
